import { Modal } from '@spotnana/blocks/src/Modal';
import { useTranslation } from 'react-i18next';

interface CheckoutCom3ds2ModalProps {
  open: boolean;
  closeModal: () => void;
  redirectUrl: string | null;
}

export function CheckoutCom3ds2Modal({ open, closeModal, redirectUrl }: CheckoutCom3ds2ModalProps) {
  const { t: tt } = useTranslation('WEB');

  if (!open || !redirectUrl) {
    return null;
  }

  return (
    <Modal
      open={open}
      scroll="body"
      header={{
        title: tt('3D Secure'),
      }}
      onClose={closeModal}
      variant="large"
    >
      <iframe title="3D Secure" src={redirectUrl} width="100%" height="720px" frameBorder={0} />
    </Modal>
  );
}
